import {createContext, useCallback, useContext, useMemo, useState} from "react";

interface CtxInfo {
    locked: boolean
    ctxState: CtxState
}
interface CtxState {
    lock: <T>(action: ()=> Promise<T>)=>Promise<T>
}
export const StepperCtx = createContext<CtxState>({lock: ()=>{ throw "" }})

export function useStepContext() {
    return useContext(StepperCtx)
}

export function useStepContextState(): CtxInfo {
    const [locked, setLocked] = useState(false)
    const lock = useCallback(async function lock<T>(action: () => Promise<T>) {
        setLocked(true)
        try {
            return await action()
        } finally {
            setLocked(false)
        }
    }, [setLocked])
    const state = useMemo(() => ({
        lock
    }), [lock])
    return {
        locked,
        ctxState: state
    }
}